import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission } from '../../features/layout/RequirePermission';
import { DashboardPage } from '../../features/dashboard/DashboardPage';
import { dashboardSearchSchema, toSearch } from '../../features/dashboard/search';

export const Route = createFileRoute('/_authed/dashboard')({
  validateSearch: dashboardSearchSchema,
  component: Guarded,
});

function DashboardRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DashboardPage search={search} onSearch={(next) => void navigate({ search: toSearch(next) })} />
  );
}

function Guarded(): React.JSX.Element {
  return (
    <RequirePermission permission="dashboard.view">
      <DashboardRoute />
    </RequirePermission>
  );
}
